import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./FormFinalstep.module.css";
import {
  getVideos,
  uploadDokumen,
  checkValid,
} from "../../store/features/CameraAndSignatureSlice";
import {insertIlustrationSignature, getSingleIlustrationSignature} from "../../store/features/CameraAndSignatureSlice";
import Header from "../../component/Header/header";
import ProgressBar from "../../component/ProgressBar/progressbar";
import { getIllustrationSPAJ } from "../../store/features/IllustrationSPAJSlice";
import { updateStatusSpaj, updateStatusCustomer } from "../../store/features/SPAJSlice";
import Spinners from "../../component/Spinner/spinners";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { StatusCustomer } from "../../component/Helper";
import { Row, Col, Modal,Form } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import { getToday, getTime } from "../../component/Helper";
import { RandomString } from "../../Config/Common";
import LockScreen from '../../component/LockScreen/lockscreen';


const ModalLengkapi = ({
  showPopupLengkapi,
  setShowPopupLengkapi,
  wordingModal,
}) => {
  return (
    <>
      <Modal
        dialogClassName={styles.modalcustom}
        centered
        show={showPopupLengkapi}
      >
        <Modal.Body>
          <div className={styles.containerModal}>
            <p className="fs-15 text-center mb-25">{wordingModal}</p>
            <div onClick={() => setShowPopupLengkapi(false)}>
              <div>
                <button className={styles.buttonnextmodal}>OK</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const PaydiA = (datasA) => {
  for (let i = 0; i < datasA.datasA.length; i++) {
    if (!datasA.dataPaydiAa[i]) {
      datasA.dataPaydiAa[i] = {};
      datasA.dataPaydiAa[i].data = false;
    }
  }

  const getDataPaydiA = (index) => {
    datasA.dataPaydiAa[index].data = true;
    if ((datasA.dataPaydiAa[index].data = true)) {
      document.getElementsByName(`fiturPaydi${index + 1}`).checked;
    }
  };
  return (
    <>
      <div>
        <div className="mt-20">
          <div className="bold fs-16">
            <Row>
              <Col className="col-10">
                <span>A. Fitur PAYDI</span>
              </Col>
              <Col className="col-2 flex-radio">
                <span>YA</span>
              </Col>
            </Row>
          </div>
        </div>
        {datasA.datasA.map((dataA, index) => (
          <div className="mt-20">
            <div className="fs-14">
              <Row>
                <Col className="col-10">
                  <div className={`d-flex flex-row justify-content-start`}>
                    <div style={{width:'5%'}}>{index + 1}.</div>
                    <div style={{width:'95%'}}>{dataA.pertanyaan}</div>
                  </div>
                </Col>
                <Col className="col-2 flex-radio">
                  <input
                    type="checkbox"
                    onChange={() => getDataPaydiA(index)}
                    defaultChecked={
                      datasA.dataPaydiAa[index].data ? true : datasA.statusCustomer > 3 ? true : false
                    }
                    value="Yes"
                    name={`fiturPaydi${index + 1}`}
                    width="30px"
                    height="30px"
                  />
                </Col>
              </Row>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const PaydiB = (datasB) => {
  for (let i = 0; i < datasB.datasB.length; i++) {
    if (!datasB.dataPaydiBb[i]) {
      datasB.dataPaydiBb[i] = {};
      datasB.dataPaydiBb[i].data = false;
    }
  }
  const getDataPaydiB = (index) => {
    datasB.dataPaydiBb[index].data = true;
    if ((datasB.dataPaydiBb[index].data = true)) {
      document.getElementsByName(`FiturPaydiB${index + 1}`).checked;
    }
  };
  return (
    <>
      <div>
        <div className="mt-20">
          <div className="bold fs-16">
            <Row>
              <Col className="col-10">
                <span>B. Biaya</span>
              </Col>
              <Col className="col-2 flex-radio">
                <span>YA</span>
              </Col>
            </Row>
          </div>
        </div>
        {datasB.datasB.map((dataB, index) =>
          index == 0 ? (
            <>
              <div className="mt-20">
                <div className="fs-14">
                  <Row>
                    <Col className="col-10">
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>{index + 1}.</div>
                        <div style={{width:'95%'}}>{dataB.pertanyaan}</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>a.</div>
                        <div style={{width:'95%'}}>biaya akuisisi (digunakan untuk komisi agen, komisibancassurance, atau komisi perantara lain);</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>b.</div>
                        <div style={{width:'95%'}}>biaya penebusan/pengakhiran Polis Asuransi (surrender charge);</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>c.</div>
                        <div style={{width:'95%'}}>biaya asuransi dasar dan biaya asuransi tambahan (rider);</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>d.</div>
                        <div style={{width:'95%'}}>biaya penarikan sebagian dana;</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>e.</div>
                        <div style={{width:'95%'}}>biaya pengalihan dana;</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>f.</div>
                        <div style={{width:'95%'}}>biaya kustodian;</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>g.</div>
                        <div style={{width:'95%'}}>biaya manajemen; dan</div>
                      </div>
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>h.</div>
                        <div style={{width:'95%'}}>biaya administrasi dan pemeliharaan polis.</div>
                      </div>
                    </Col>
                    <Col className="col-2 flex-radio">
                      <input
                        type="checkbox"
                        onChange={() => getDataPaydiB(index)}
                        defaultChecked={
                          datasB.dataPaydiBb[index].data ? true : datasB.statusCustomer > 3 ? true : false
                        }
                        value="Yes"
                        name={`FiturPaydiB${index + 1}`}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="mt-20">
                <div className="fs-14">
                  <Row>
                    <Col className="col-10">
                      <div className={`d-flex flex-row justify-content-start`}>
                        <div style={{width:'5%'}}>{index + 1}.</div>
                        <div style={{width:'95%'}}>{dataB.pertanyaan}</div>
                      </div>
                    </Col>
                    <Col className="col-2 flex-radio">
                      <input
                        type="checkbox"
                        value="Yes"
                        name={`FiturPaydiB${index + 1}`}
                        defaultChecked={
                          datasB.dataPaydiBb[index].data ? true :  datasB.statusCustomer > 3 ? true : false
                        }
                        onChange={() =>
                          getDataPaydiB(
                            index,
                            datasB.datasB,
                            datasB.dataPaydiBb,
                            datasB.setDataPaydiBb,
                            datasB.setDataValueB
                          )
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};

const PaydiC = (datasC) => {
  for (let i = 0; i < datasC.datasC.length; i++) {
    if (!datasC.dataPaydiCc[i]) {
      datasC.dataPaydiCc[i] = {};
      datasC.dataPaydiCc[i].data = false;
    }
  }
  const getDataPaydiC = (index) => {
    datasC.dataPaydiCc[index].data = true;
    if ((datasC.dataPaydiCc[index].data = true)) {
      document.getElementsByName(`FiturPaydiC${index + 1}`).checked;
    }
  };
  return (
    <>
      <div className="mt-20">
        <div className="bold fs-16">
          <Row>
            <Col className="col-10">
              <span>C. Nilai dan Risiko Investasi</span>
            </Col>
            <Col className="col-2 flex-radio">
              <span>YA</span>
            </Col>
          </Row>
        </div>
      </div>
      {datasC.datasC.map((dataC, index) =>
        index == 1 ? (
          <>
            <div className="mt-20">
              <div className="fs-14">
                <Row>
                  <Col className="col-10">
                    <div className={`d-flex flex-row justify-content-start`}>
                      <div style={{width:'5%'}}>{index + 1}.</div>
                      <div style={{width:'95%'}}>{dataC.pertanyaan}</div>
                    </div>
                    <div className={`d-flex flex-row justify-content-start`}>
                      <div style={{width:'5%'}}>a.</div>
                      <div style={{width:'95%'}}>Pembayaran biaya asuransi untuk produk dasar dan biaya
                      produk asuransi tambahan berdasarkan Polis Asuransi dan
                      biaya-biaya lainnya kepada Perusahaan dalam rangka menjaga
                      agar perlindungan atas risiko pada asuransi dasar dan
                      asuransi tambahan tetap berlaku terutama dalam hal saya
                      sebagai Pemegang Polis tidak dapat melakukan pembayaran
                      Premi atau Kontribusi secara reguler sebagaimana yang
                      disepakati dalam Polis Asuransi; dan</div>
                    </div>
                    <div className={`d-flex flex-row justify-content-start`}>
                      <div style={{width:'5%'}}>b.</div>
                      <div style={{width:'95%'}}>Pembayaran manfaat yang dikaitkan dengan investasi
                      kepada Pemegang Polis, Tertanggung, atau Peserta, baik
                      melalui penarikan Nilai Tunai dalam periode asuransi
                      ataupun pembayaran Nilai Tunai pada akhir periode asuransi
                      setelah memperhitungkan pembayaran sebagaimana dimaksud
                      pada huruf a, dalam hal terdapat pembayaran sebagaimana
                      dimaksud pada huruf a.</div>
                    </div>
                  </Col>
                  <Col className="col-2 flex-radio">
                    <input
                      type="checkbox"
                      value="Yes"
                      defaultChecked={
                        datasC.dataPaydiCc[index].data ? true  : datasC.statusCustomer > 3 ? true : false
                      }
                      onChange={() => getDataPaydiC(index)}
                      name={`FiturPaydiC${index + 1}`}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mt-20">
              <div className="fs-14">
                <Row>
                  <Col className="col-10">
                    <div className={`d-flex flex-row justify-content-start`}>
                      <div style={{width:'5%'}}>{index + 1}.</div>
                      <div style={{width:'95%'}}>{dataC.pertanyaan}</div>
                    </div>
                  </Col>
                  <Col className="col-2 flex-radio">
                    <input
                      type="checkbox"
                      defaultChecked={
                        datasC.dataPaydiCc[index].data ? true : datasC.statusCustomer > 3 ? true : false
                      }
                      onChange={() => getDataPaydiC(index)}
                      value="Yes"
                      name={`FiturPaydiC${index + 1}`}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </>
        )
      )}
      <div className="mt-40">
        <div className="bold fs-16">
          Demikian Pernyataan Pemahaman sebagaimana tertuang dalam butir A, B,
          dan C pada tabel di atas, Saya buat sesuai dengan kondisi yang
          sebenarnya tanpa ada unsur paksaan maupun tekanan dari pihak manapun
          dan agar dapat dipergunakan sebagaimana mestinya.
        </div>
      </div>
    </>
  );
};

export default function FormFinalStep() {
  let dispatch = useDispatch();
  const [dataSig, setDataSig] = useState("");
  const [getSignature, setGetSignature] = useState(false)
  let data = "";
  let date = getToday();
  const [dataValueA, setDataValueA] = useState(false);
  const [dataPaydiAa, setDataPaydiAa] = useState({});
  const [dataPaydiBb, setDataPaydiBb] = useState({});
  const [dataPaydiCc, setDataPaydiCc] = useState({});
  const Paydis = require("./PDF/FormPernyataanPAYDI.pdf");
  const nonPaydis = require("./PDF/FormPernyataanNonPAYDI.pdf");
  let [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const [pdfInfo, setPdfInfo] = useState([]);
  const { SPAJDetail } = useSelector((state) => state.SPAJsDetail);
  const { DeviceId } = useSelector((state) => state.DeviceId);
  const { SPAJs } = useSelector((state) => state.SPAJs);
  const [statusCustomer, setStatusCustomer] = useState("");
  const [isUnitLink, setIsUnitLink] = useState(0);
  let [showPopupLengkapi, setShowPopupLengkapi] = useState(false);
  const sigCanvas = useRef({});
  let [wordingModal, setWordingModal] = useState("Mohon mengisi tanda tangan");
  const [showHideError, setShowHideError] = useState(false);

  const [listAccordion, setListAccordion] = useState([
    {
      index: 0,
      checked: false,
    }
  ]);
  
  const onClickCheckbox = (idx, event, setListAccordion, listAccordion) => {

    listAccordion[idx].checked = event.target.checked;
    //need to reclean supaya statenya update
    listAccordion = JSON.parse(JSON.stringify(listAccordion));

    setListAccordion(listAccordion);
  };

  let [datasA, setDatasA] = useState([
    {
      pertanyaan:
        "Saya memahami bahwa PAYDI merupakan PRODUK ASURANSI yang memberikan manfaat perlindungan atas risiko dan manfaat akumulasi investasi yang tergantung kinerja investasi yang saya pilih.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi1]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa PAYDI bukan merupakan produk tabungan atau deposito dari perbankan.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi2]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa PAYDI merupakan produk asuransi jangka panjang dan tidak sesuai bagi Pemegang Polis, Tertanggung, atau Peserta yang memiliki kebutuhan penggunaan dana yang bersumber dari PAYDI dalam jangka pendek.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi3]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa manfaat asuransi berupa manfaat perlindungan atas risiko (misalnya santunan meninggal dunia atau sakit) hanya akan diberikan jika terjadi risiko sebagaimana tercantum dalam Polis Asuransi.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi4]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa ILUSTRASI INVESTASI HANYA MERUPAKAN GAMBARAN mengenai hasil nilai investasi Produk PAYDI dan skenario yang MUNGKIN terjadi di masa mendatang dan BUKAN MERUPAKAN JAMINAN ATAS NILAI INVESTASI YANG AKAN SAYA TERIMA di masa mendatang. Saya memahami bahwa hasil investasi aktual di masa yang akan datang dapat lebih rendah dari informasi yang tercantum pada ilustrasi yang diberikan.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi5]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa Saya DAPAT melakukan pembatalan polis PAYDI selama periode mempelajari Polis Asuransi (freelook period) dan akan menerima pengembalian Premi atau Kontribusi setelah dikurangi biayabiaya sesuai dengan ketentuan Polis Asuransi.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi6]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa pada PAYDI terdapat klausul pengecualian sehingga manfaat perlindungan risiko tidak dapat dibayarkan dalam hal terjadi kondisi yang dikecualikan tersebut.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi7]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa manfaat fitur tambahan (jika ada) hanya akan diberikan jika memenuhi kriteria yang tercantum di dalam Polis Asuransi.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi8]:checked"
      )?.value,
    },
  ]);

  let [datasB, setDatasB] = useState([
    {
      pertanyaan:
        "Saya memahami jenis, besaran, dan waktu pembebanan biaya - biaya terkait PAYDI selama periode asuransi sebagaimana tercantum dalam Polis Asuransi, meliputi:",
      subpertanyaan: {
        a: "biaya akuisisi (digunakan untuk komisi agen, komisibancassurance, atau komisi perantara lain);",
        b: "biaya penebusan/pengakhiran Polis Asuransi (surrender charge);",
        c: "biaya asuransi dasar dan biaya asuransi tambahan (rider)",
        d: "biaya penarikan sebagian dana",
        e: "biaya pengalihan dana",
        f: "biaya kustodian",
        g: "biaya manajemen; dan",
        h: "biaya administrasi dan pemeliharaan polis.",
      },
    },
    {
      pertanyaan:
        " Saya memahami bahwa apabila Saya mengambil cuti Premi atau Kontribusi (premium/contribution holiday), maka biaya-biaya yangtimbul sebagaimana tercantum dalam Polis Asuransi akan tetap dibebankan dan akan mengurangi nilai pokok (akumulasi Premi atau Kontribusi yang telah dibayarkan) dan hasil investasi sesuai dengan ketentuan Polis Asuransi.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi2]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa setelah berakhir periode pembayaran Premi atau Kontribusi, perusahaan akan mengenakan biaya-biaya yang dibebankan kepada Nilai Tunai sesuai dengan ketentuan dalam Polis Asuransi.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi3]:checked"
      )?.value,
    },
    {
      pertanyaan:
        "Saya memahami bahwa dalam hal Saya membatalkan Polis Asuransi setelah periode mempelajari polis (free look period) namun sebelum periode asuransi berakhir, maka nilai investasi Saya akan dikenakan biaya penebusan polis (surrender charge). Disamping biaya penebusan polis (surrender charge), seluruh Premi atau Kontribusi yang telah dibayarkan dalam periode asuransi yang telah berjalan juga telah dikurangi dengan biaya yang disebutkan sebagaimana angka 1. Konsekuensi dari hal tersebut, saya pahami dalam kondisi tertentu (misalnya nilai investasi yang sedang menurun di pasar modal) DAPAT BERPOTENSI MENGAKIBATKAN TIDAK ADANYA NILAI INVESTASI YANG TERSISA.",
      answer: document.querySelector(
        "input[type=radio][name=FiturPaydi4]:checked"
      )?.value,
    },
  ]);

  let [datasC, setDatasC] = useState([
    {
      pertanyaan:
        "Saya memahami bahwa nilai investasi Saya TIDAK DIJAMIN dan akan tergantung pada besaran Premi atau Kontribusi, hasil investasi atas jenis investasi yang Saya pilih dan biaya-biaya yang dibebankan pada Polis Asuransi",
    },
    {
      pertanyaan:
        " Saya memahami bahwa nilai investasi yang tercermin dari saldo Nilai Tunai dapat digunakan untuk:",
    },
    {
      pertanyaan:
        "Saya memahami bahwa Premi atau Kontribusi yang telah Saya bayar dan setelah dikurangi biaya-biaya yang timbul akan ditempatkan pada instrumen investasi pasar modal dan/atau pasar uang sesuai dengan jenis Subdana yang Saya pilih yang memiliki risiko investasi yang berbeda-beda dan telah dijelaskan agen/tenaga pemasar kepada Saya",
    },
    {
      pertanyaan:
        "Saya memahami bahwa unsur investasi pada PAYDI mengandung risiko- risiko kerugian yang meliputi tetapi tidak terbatas pada risiko pasar (naik turunnya harga instrumen investasi), risiko nilai tukar, risiko likuiditas, risiko kredit, risiko perubahan peraturan perpajakan dan risiko lain-lain",
    },
    {
      pertanyaan:
        "Saya memahami bahwa biaya-biaya sebagaimana dimaksud padabutir B dan risiko sebagaimana dimaksud pada butir C angka 4, DAPAT MENGAKIBATKAN BERKURANGNYA ATAU MENGHILANGKAN NILAI INVESTASI SAYA DAN BAHKAN DAPAT MENGHILANGKAN PREMI ATAU KONTRIBUSI YANG TELAH DIBAYARKAN DAN BERAKHIRNYA ASURANSI",
    },
  ]);

  useEffect(async () => {
      setLoading(true);
      await setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink));
      setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
  
      if(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink) > 3)
        {
          listAccordion.forEach((e) => {
            e.checked = true;
          });
          setListAccordion(listAccordion);
        }
        setLoading(false);


  }, [SPAJs]);

  // useEffect(() => {
  //   let dataReqSignature = {
  //     deviceId: `${DeviceId.deviceId}`,
  //     userName: `${SPAJDetail.dataSpaj.email}`,
  //     spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
  //     documentId: "PAYDI",
  //   };
  //   dispatch(getSingleIlustrationSignature(dataReqSignature))
  //   .then((res) => {
  //     console.log("get signature : ", res)
  //     if(res.payload.status == "OK" && res.payload.Signature.length > 0){
  //       setDataSig(res.payload.Signature[0].TRSN_ClientSignature);
  //       setGetSignature(true);
  //     }
  //     setLoading(false);
  //   })
  //   .catch((err) => {
  //     setLoading(false);
  //   });
  // }, [])

  // useEffect(()=>{
  //     let temp = true
  //     for (const key in dataPaydiAa) {
  //         if(dataPaydiAa[key].data == false){
  //             temp = false
  //         }
  //       }
  //     setDataValueA(temp)
  // },[dataPaydiAa])
  const updateStatus = () => {
    if (statusCustomer == 1) {
      let detailData = {
        deviceId: `${DeviceId.deviceId}`,
        userName: `${SPAJs.spajHeader?.userName}`,
        spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
        agentStatus: "IPC",
        customerStatus: "CI",
      };
      dispatch(updateStatusSpaj(detailData)).then((res) => {});
    }
  };

  const Pernyataan = ({ statusCustomer,sigCanvas,insertIlustrationSignature, setDataSig, setGetSignature, getSignature }) => {
    const MOBILE_WIDTH = 576;
    // function useWindowSize() {
    //     const [size, setSize] = useState([0, 0]);
    //     useLayoutEffect(() => {
    //         function updateSize() {
    //             window.innerWidthReal = window.innerWidth * 0.45
    //             window.innerHeightReal = window.innerHeight * 0.15

    //             setSize([window.innerWidthReal, window.innerHeightReal]);
    //         }
    //         window.addEventListener('resize', updateSize);
    //         updateSize();
    //         return () => window.removeEventListener('resize', updateSize);
    //     }, []);
    //     return size;
    //     }

    //     const [widthss, heightss] = useWindowSize();
    //     const canvaswidth  = widthss * 0.93;
    //     const canvasheight  = heightss * 0.85;

    const clearSignature = () => {
      sigCanvas.current.clear();
    };

    const handleEnd = () => {
      data = sigCanvas.current.toDataURL();
    };

    const sendCanvas = async (insertIlustrationSignature,setDataSig, setGetSignature) => {
      setLoading(true)
      let dataSignature = {
        deviceId: `${DeviceId.deviceId}`,
        agentCode: `${SPAJDetail.dataSpaj.agentCode}`,
        leadNumber: `${SPAJDetail.dataPH.TCLN_LeadNumber}`,
        spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
        clientCode: `${SPAJDetail.dataPH.TREL_ClientCode}`,
        clientNumber: `${SPAJDetail.dataPH.TCLN_ClientNumber}`,
        documentId: "PAYDI",
        location: `${SPAJDetail.dataPH.TCLN_HomeState}`,
        signatureDate: date,
        clientSignature: data === "" ? dataSig : data.split("data:image/png;base64,")[1],
        userName: `${SPAJDetail.dataSpaj.email}`,
      };

      await dispatch(insertIlustrationSignature(dataSignature))
      .then((res) => {
        console.log(res,"hures")
        if(res.payload.status == "OK"){
          setDataSig(res.payload.Signature.TRSN_ClientSignature)
          setTimeout(()=>{
            setGetSignature(true)
          },300)
        }else{
          setShowHideError(true);
        }
        setLoading(false)
      })
      .catch(err=>{
        setLoading(false)
        setShowHideError(true);
        return err
      });
    }
    // TCLN_HomeAddress,TCLN_HomeAddressDetail ,TCLN_HomeCity ,TCLN_HomeState
    let Alamat = [
      SPAJDetail.dataPH?.TCLN_HomeAddress,
      SPAJDetail.dataPH?.TCLN_HomeAddressDetail,
      SPAJDetail.dataPH?.TCLN_HomeAddressDetail,
      SPAJDetail.dataPH?.TCLN_HomeAddress3,
      SPAJDetail.dataPH?.TCLN_HomeAddress4,
      SPAJDetail.dataPH?.TCLN_HomeVillage,
      SPAJDetail.dataPH?.TCLN_HomeDistrict,
      SPAJDetail.dataPH?.TCLN_HomeCity,
      SPAJDetail.dataPH?.TCLN_HomeState
    ].filter(item => item).join(', ');
    return (
      <>
        {showPopupLengkapi == true && (
          <ModalLengkapi
            showPopupLengkapi={showPopupLengkapi}
            setShowPopupLengkapi={setShowPopupLengkapi}
            wordingModal={wordingModal}
          />
        )}
        <div>
          <div>
            {SPAJs.spajHeader?.isUnitLink == 0 ? (
              <>
                <div className="font-wording">
                  FORMULIR PERNYATAAN PEMAHAMAN PRODUK ASURANSI GENERALI
                  INDONESIA
                </div>

                <div className="mt-20">
                  <div className="border-form">
                    <ul>
                      <li>
                        Calon Pemegang Polis, Tertanggung, atau Peserta WAJIB
                        membaca dan memahami seluruh informasi terkait Produk
                        Asuransi yang akan dibeli termasuk namun tidak terbatas
                        pada Ringkasan Informasi Produk dan Layanan (“RIPLAY”)
                        Umum, RIPLAY Personal (termasuk Ilustrasi), dan isi dari
                        Pernyataan Pemahaman ini.
                      </li>
                      <li>
                        Apabila calon Pemegang Polis, Tertanggung, atau Peserta
                        tidak memahami/tidak setuju atas isi dari Pernyataan
                        Pemahaman ini atau apa yang dijelaskan oleh Tenaga
                        Pemasar berbeda dengan apa yang tercantum dalam
                        Pernyataan Pemahaman ini, maka calon Pemegang Polis
                        JANGAN membubuhkan tanda tangan calon Pemegang Polis,
                        Tertanggung, atau Peserta dan TIDAK melanjutkan proses
                        pembelian Produk Asuransi.
                      </li>
                      <li>
                        <p>
                          Pernyataan Pemahaman ini WAJIB diisi sendiri oleh:{" "}
                        </p>
                        <p>- Pemegang Polis untuk polis individual, atau</p>
                        <p>
                          - Pemegang Polis dan Tertanggung, atau Peserta untuk
                          polis kumpulan.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mt-40">
                  <div className="bold fs-16">
                    Yang bertandatangan di bawah ini:
                  </div>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <div className="font-grey">Nama</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataSpaj?.fullName}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <div className="font-grey">NIK</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataPH?.TCLN_IdentityNumber}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      style={{ marginTop: 10 }}
                    >
                      <div className="font-grey">Tempat Lahir</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataPH?.TCLN_PlaceBirth}
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      style={{ marginTop: 10 }}
                    >
                      <div className="font-grey">Tanggal Lahir</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataPH?.TCLN_DateBirth}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div className="font-grey">Alamat</div>
                      <div className="border-pembayaran mt-10">{Alamat}</div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-40">
                  <div className="bold fs-16">
                    Memutuskan untuk membeli Produk Asuransi dari Perusahaan
                    Asuransi Generali Indonesia dengan
                  </div>
                </div>
                <div className="mt-40">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div className="font-grey">Nama Produk</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataBenefitSpaj?.basic.ProductName}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div className="font-grey">Mata Uang</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataBenefitSpaj?.basic.Currency}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div className="font-grey">Nomor Ilustrasi</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataBenefitSpaj?.basic.IllustrationNumber}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div className="font-grey">Nomor SPAJ</div>
                      <div className="border-pembayaran mt-10">
                        {SPAJDetail.dataSpaj?.spajNumber}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mt-40">
                  <div className="bold fs-16">
                    Selanjutnya, saya dengan ini menyatakan bahwa saya telah:
                  </div>
                </div>
                <div className="mt-40">
                  <div className="fs-14">
                    <ol>
                      <li>
                        Menerima Ringkasan Informasi Produk dan Layanan
                        (“RIPLAY”) versi umum dan RIPLAY versi personal
                        (termasuk ilustrasi); dan
                      </li>
                      <li>
                        Mendapatkan penjelasan, membaca dan memahami informasi
                        penting yang tercantum dalam dokumen pada nomor 1,
                        termasuk fitur produk, biaya-biaya yang akan dibebankan
                        sebagaimana tercantum dalam RIPLAY Umum, RIPLAY Personal
                        (termasuk ilustrasi) yang akan saya beli.
                      </li>
                      <li>
                        Selain itu, saya menyatakan bahwa Produk Asuransi yang
                        saya beli telah sesuai dengan kebutuhan dan kemampuan
                        keuangan dan profil risiko saya berdasarkan Financial
                        Need Analysis (FNA) yang telah saya isi.
                      </li>
                      <li>
                        Saya memahami bahwa saya dapat melakukan pembatalan
                        polis selama periode mempelajari Polis Asuransi
                        (freelook period) dan akan menerima pengembalian Premi
                        atau Kontribusi setelah dikurangi biaya-biaya sesuai
                        dengan ketentuan Polis Asuransi.
                      </li>
                    </ol>
                  </div>
                </div>
                <div className="mt-40">
                  <div className="bold fs-16">
                    Demikian Pernyataan Pemahaman sebagaimana tertuang di atas.
                    Saya buat sesuai dengan kondisi yang sebenarnya tanpa ada
                    unsur paksaan maupun tekanan dari pihak manapun dan agar
                    dapat dipergunakan sebagaimana mestinya.
                  </div>
                </div>
                <div className="mt-40">
                  <Form>
                      <Form.Check
                        key={`default-checkbox`}
                        className=" mt-3 mb-3"
                        onChange={(event) =>
                          onClickCheckbox(
                            0,
                            event,
                            setListAccordion,
                            listAccordion
                          )
                        }
                        // disabled
                        type={"checkbox"}
                        checked={listAccordion[0]?.checked}
                        id={`default-checkbox`}
                        label={(<><b>Dengan ini Saya setuju atas segala syarat dan ketentuan yang berlaku pada PT Asuransi Jiwa Generali Indonesia dalam memproses permohonan Asuransi Jiwa ini</b></>)}
                      />
                    </Form>
                </div>
                  

                <div className="mt-40">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={2}>
                      <div className="bold fs-16">Nama</div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <input
                        type="Text"
                        disabled
                        value={SPAJDetail.dataSpaj?.fullName}
                        name="NameNonPaydi"
                      />
                    </Col>
                  </Row>
                </div>
                <div className="mt-20">
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={2}>
                      <div className="bold fs-16">Tanggal</div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <input
                        type="Text"
                        value={date}
                        disabled
                        name="tanggalNonPaydi"
                      />
                    </Col>
                  </Row>
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="font-wording">
                    FORMULIR PERNYATAAN PEMAHAMAN PRODUK ASURANSI YANG DIKAITKAN
                    DENGAN INVESTASI (PAYDI) GENERALI INDONESIA
                  </div>
                  <div className="mt-20">
                    <div className="border-form">
                      <ul>
                        <li>
                          Calon Pemegang Polis, Tertanggung, atau Peserta WAJIB
                          membaca dan memahami seluruh informasi terkait Produk
                          PAYDI yang akan dibeli termasuk namun tidak terbatas
                          pada Ringkasan Informasi Produk dan Layanan (RIPLAY)
                          Umum, RIPLAY Personal (termasuk ilustrasi), dan fund
                          fact sheet Subdana PAYDI, serta isi dari pernyataan
                          pemahaman ini.
                        </li>
                        <li>
                          Apabila calon pemegang Polis, Tertanggung, atau
                          Peserta tidak memahami/tidak setuju atas isi dari
                          Pernyataan Pemahaman ini atau apa yang dijelaskan oleh
                          Tenaga Pemasar berbeda dengan apa yang tercantum dalam
                          pernyataan pemahaman ini, maka calon Pemegang Polis,
                          Tertanggung, atau Peserta JANGAN membubuhkan tanda
                          tangan calon pemegang polis, Tertanggung, atau Peserta
                          dan TIDAK melanjutkan proses pembelian Produk PAYDI.
                        </li>
                        <li>
                          Pernyaan pemahaman ini WAJIB diisi sendiri oleh calon
                          Pemegang Polis, Tertanggung, atau Peserta (Tidak boleh
                          diwakilkan oleh Tenaga Pemasar)
                        </li>
                      </ul>
                    </div>
                    <div className="mt-40">
                      <div className="bold fs-16">
                        Yang bertandatangan di bawah ini:
                      </div>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                          <div className="font-grey">Nama</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataSpaj?.fullName}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                          <div className="font-grey">NIK</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataPH?.TCLN_IdentityNumber}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          style={{ marginTop: 10 }}
                        >
                          <div className="font-grey">Tempat Lahir</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataPH?.TCLN_PlaceBirth}
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          style={{ marginTop: 10 }}
                        >
                          <div className="font-grey">Tanggal Lahir</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataPH?.TCLN_DateBirth}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="font-grey">Alamat</div>
                          <div className="border-pembayaran mt-10">
                            {Alamat}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-40">
                      <div className="bold fs-16">
                        Memutuskan untuk membeli Produk PAYDI dari Perusahaan
                        Asuransi Generali Indonesia dengan
                      </div>
                    </div>
                    <div className="mt-40">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="font-grey">Nama Produk</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataBenefitSpaj?.basic.ProductName}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="font-grey">Mata Uang</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataBenefitSpaj?.basic.Currency}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="font-grey">Nomor Ilustrasi</div>
                          <div className="border-pembayaran mt-10">
                            {
                              SPAJDetail.dataBenefitSpaj?.basic
                                .IllustrationNumber
                            }
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-20">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="font-grey">Nomor SPAJ</div>
                          <div className="border-pembayaran mt-10">
                            {SPAJDetail.dataSpaj?.spajNumber}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="mt-40">
                    <div className="bold fs-16">
                      Selanjutnya, saya dengan ini menyatakan bahwa saya telah:
                    </div>
                  </div>
                  <div className="mt-40">
                    <div className="fs-14">
                      <ol>
                        <li>
                          Menerima ringkasan informasi produk dan layanan
                          (RIPLAY) versi umum dan RIPLAY versi personal
                          (termasuk ilustrasi), serta laporan Subdana (fund fact
                          sheet) PAYDI; dan
                        </li>
                        <li>
                          Mendapatkan penjelasan, membaca dan memahami informasi
                          penting yang tercantum dalam dokumen pada huruf a,
                          termasuk fitur PAYDI, biaya-biaya yang akan dibebankan
                          dan potensi risiko investasi yang dapat terjadi di
                          pasar modal dan/atau pasar uang terkait Produk PAYDI
                          sebagaimana tercantum dalam RIPLAY Umum, RIPLAY
                          Personal (termasuk ilustrasi), dan fund fact sheet
                          Subdana PAYDI yang akan saya beli.
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="mt-40">
                    <div className="bold fs-16">
                      Selain itu, saya menyatakan bahwa Produk PAYDI yang saya
                      beli telah sesuai dengan kebutuhan dan kemampuan keuangan
                      dan profil risiko saya berdasarkan Financial Need Analysis
                      (FNA) dan Risk Profile Questionnaire (RPQ) yang telah saya
                      isi. Terkait dengan pemahaman atas Produk PAYDI, berikut
                      ini adalah tingkat pernyataan pemahaman saya atas PAYDI,
                      termasuk namun tidak terbatas pada:
                    </div>
                  </div>
                  <div className="mt-40">
                    <div className="bold fs-16">PERNYATAAN</div>
                  </div>
                  <PaydiA
                    datasA={datasA}
                    dataPaydiAa={dataPaydiAa}
                    setDataPaydiAa={setDataPaydiAa}
                    setDataValueA={setDataValueA}
                    statusCustomer={statusCustomer}
                  />
                </div>
                <PaydiB
                  datasB={datasB}
                  dataPaydiBb={dataPaydiBb}
                  setDataPaydiBb={setDataPaydiBb}
                  statusCustomer={statusCustomer}
                />
                <div>
                  <PaydiC
                    datasC={datasC}
                    dataPaydiCc={dataPaydiCc}
                    setDataPaydiCc={setDataPaydiCc}
                    statusCustomer={statusCustomer}
                  />
                  <div className="mt-40">
                    <Form>
                      <Form.Check
                        key={`default-checkbox`}
                        className=" mt-3 mb-3"
                        onChange={(event) =>
                          onClickCheckbox(
                            0,
                            event,
                            setListAccordion,
                            listAccordion
                          )
                        }
                        // disabled
                        type={"checkbox"}
                        checked={listAccordion[0]?.checked}
                        id={`default-checkbox`}
                        label={(<><b>Dengan ini Saya setuju atas segala syarat dan ketentuan yang berlaku pada PT Asuransi Jiwa Generali Indonesia dalam memproses permohonan Asuransi Jiwa ini</b></>)}
                      />
                    </Form>
                  </div>

                  <div className="mt-40">
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={1}>
                        <div className="bold fs-16">Nama</div>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={1}>
                        {/* <div className='border-form'> */}
                        <input
                          type="Text"
                          disabled
                          value={SPAJDetail.dataSpaj?.fullName}
                          name="NamePaydi"
                        />
                        {/* </div> */}
                      </Col>
                    </Row>
                  </div>
                  <div className="mt-20">
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={1}>
                        <div className="bold fs-16">Tanggal</div>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={1}>
                        {/* <div className='border-form'></div> */}
                        <input
                          type="Text"
                          value={date}
                          disabled
                          name="tanggalPaydi"
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="border-form mt-40">
                    <ul>
                      <li>
                        Untuk setiap pernyataan pada tabel diatas, calon
                        Pemegang Polis, Tertanggung, atau Peserta harus
                        membubuhkan Checklist pada kolom "YA" jika telah
                        memahami pernyataan dimaksud atau kolom "TIDAK" jika
                        belum memahami pernyataan dimaksud.
                      </li>
                      <li>
                        Calon Pemegang Polis, Tertanggung, atau Peserta dapat
                        membeli PAYDI apabila telah menyatakan memahami seluruh
                        pernyataan tersebut di atas, dengan memberikan Checklist
                        pada kolom "YA".
                      </li>
                      <li>
                        Apabila terdapat pernyataan yang di Checklist pada kolom
                        "TIDAK" Perusahaan tidak dapat menjual PAYDI kepada
                        calon pemegang polis, tertanggung, atau peserta. Apabila
                        calon pemegang polis, tertanggung, atau peserta tetap
                        bermaksud membeli PAYDI perusahaan harus menjelaskan
                        kembali mengenai syarat dan kondisi PAYDI kepada calon
                        pemegang polis, tertanggung, atau peserta serta meminta
                        calon pemegang polis, tertanggung, atau peserta untuk
                        melakukan pengisian ulang pernyataan ini.
                      </li>
                      <li>
                        <p>
                          Pemegang Polis, Tertanggung, atau Peserta yang
                          memberikan Checklist dan tanda tangan pernyataan ini
                          adalah:
                        </p>
                        <p>- Pemegang polis untuk polis individual, atau</p>
                        <p>
                          - Pemegang polis dan tertanggung, atau peserta untuk
                          polis kumpulan
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  const showPDF = async (getSignature) => {
    setLoading(true);
    let temp = true;

    if (SPAJs.spajHeader?.isUnitLink == 0) {
      // if (sigCanvas.current.isEmpty()) {
      //   setWordingModal("Mohon mengisi tanda tangan");
      //   setShowPopupLengkapi(true);
      //   setLoading(false);
      //   return;
      // }
      if(listAccordion[0].checked == false){
        setWordingModal("Mohon menyetujui dengan melakukan checklist pada pernyataan");
        setShowPopupLengkapi(true);
        setLoading(false);
        return;
      }

      nextPage();
      navigate( '/persetujuan')

    } else {
      
      var selectedA1 =
        document.querySelector("input[type=checkbox][name=fiturPaydi1]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi1]:checked"
            ).value;
      var selectedA2 =
        document.querySelector("input[type=checkbox][name=fiturPaydi2]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi2]:checked"
            ).value;
      var selectedA3 =
        document.querySelector("input[type=checkbox][name=fiturPaydi3]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi3]:checked"
            ).value;
      var selectedA4 =
        document.querySelector("input[type=checkbox][name=fiturPaydi4]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi4]:checked"
            ).value;
      var selectedA5 =
        document.querySelector("input[type=checkbox][name=fiturPaydi5]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi5]:checked"
            ).value;
      var selectedA6 =
        document.querySelector("input[type=checkbox][name=fiturPaydi6]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi6]:checked"
            ).value;
      var selectedA7 =
        document.querySelector("input[type=checkbox][name=fiturPaydi7]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi7]:checked"
            ).value;
      var selectedA8 =
        document.querySelector("input[type=checkbox][name=fiturPaydi8]:checked") ==
        null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=fiturPaydi8]:checked"
            ).value;

      var selectedB1 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiB1]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiB1]:checked"
            ).value;
      var selectedB2 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiB2]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiB2]:checked"
            ).value;
      var selectedB3 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiB3]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiB3]:checked"
            ).value;
      var selectedB4 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiB4]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiB4]:checked"
            ).value;

      var selectedC1 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiC1]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiC1]:checked"
            ).value;
      var selectedC2 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiC2]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiC2]:checked"
            ).value;
      var selectedC3 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiC3]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiC3]:checked"
            ).value;
      var selectedC4 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiC4]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiC4]:checked"
            ).value;
      var selectedC5 =
        document.querySelector(
          "input[type=checkbox][name=FiturPaydiC5]:checked"
        ) == null
          ? ""
          : document.querySelector(
              "input[type=checkbox][name=FiturPaydiC5]:checked"
            ).value;

      let pernyataanCheck = false;

      if (
        selectedA1 == "" ||
        selectedA2 == "" ||
        selectedA3 == "" ||
        selectedA4 == "" ||
        selectedA5 == "" ||
        selectedA6 == "" ||
        selectedA7 == "" ||
        selectedA8 == "" ||
        selectedB1 == "" ||
        selectedB2 == "" ||
        selectedB3 == "" ||
        selectedB4 == "" ||
        selectedC1 == "" ||
        selectedC2 == "" ||
        selectedC3 == "" ||
        selectedC4 == "" ||
        selectedC5 == ""
      ) {
        setLoading(false);
        pernyataanCheck = true;
      }

      if(listAccordion[0].checked == false){
        setWordingModal("Mohon menyetujui dengan melakukan checklist pada pernyataan");
        setShowPopupLengkapi(true);
        setLoading(false);
        return;
      }if (pernyataanCheck) {
        setWordingModal("Mohon melengkapi seluruh pernyataan");
        setShowPopupLengkapi(true);
        return;
      }
      nextPage();
      navigate( '/persetujuan')

    }
  };

  const nextPage = () => {
    if (statusCustomer == 3) {
        let detailData = {
            deviceId: `${DeviceId.deviceId}`,
            userName: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
            agentStatus: "IPC",
            customerStatus: "CP"
        }
        dispatch(updateStatusSpaj(detailData)).then(res => {
            // UPDATE LOCAL STATUS CUSTOMER KE CS
            dispatch(updateStatusCustomer("CP"));
        })
    }
}


  return (
    <>
      {statusCustomer < 3 &&<LockScreen/>}
      {loading == true && <Spinners />}
      <div>
        <Header />
        <div>
          <div className="g-0 welcome-container">
            {/* <iframe src={pdfInfo} type="application/pdf" /> */}
            <div className={`position-relative ${styles.bgContainer}`}>
              <ProgressBar step="1" status={statusCustomer} isUnitlink={isUnitLink}/>
              <div className={styles.allCardGreyFormfinalstep}>
                <div className={styles.cardContainer}>
                  <Pernyataan statusCustomer ={statusCustomer} sigCanvas={sigCanvas} insertIlustrationSignature={insertIlustrationSignature} setDataSig={setDataSig} setGetSignature={setGetSignature} getSignature={getSignature}/>
                  <div
                    className={`position-relative`}
                    style={{ height: 40, marginBottom: 30, marginTop: 30 }}
                  >
                    <div className={styles.pbotton}>
                        <div style={{ display: 'flex' }}>
                            <div>
                                <button className={styles.buttonkembali} onClick={() => navigate( '/spaj-detail')}>Kembali</button>
                            </div>
                            <div>
                                <button className={styles.buttonnext} onClick={() => showPDF()}>Selanjutnya</button>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.linkFooter}>
                <div>www.generali.co.id</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal dialogClassName={styles.modalcustom} centered show={showHideError}>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
            {/* <p className="fs-15 text-center">Gagal Konfirmasi. {errorMessage}</p> */}
            <p className="fs-15 text-center">Ada kesalahan pada saat tanda tangan. Silakan melakukan tanda tangan ulang.</p>
              <div>
                <button className={styles.buttonkembalimodal} onClick={() => setShowHideError(false)}>OK</button>
              </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}